export default __webpack_public_path__ + "static/media/Jones_05.25b782ad.jpg";